import { Datalayer, DatalayerZone, defineDirective, IOmniaShell, shell, sum } from "../../omnia"
import { IZoneEditor } from "../types"

export class YieldRecalibrateCtrl {

    static create(): ng.IDirective {
        return defineDirective(YieldRecalibrateCtrl, "app/datalayers/edit/yield/recalibrate.html", {
            editor: "=",
        })
    }

    private editor: IZoneEditor

    public totalYield: number
    public originalTotalYield: number
    public weightedYield: number
    public canReset: boolean = false

    static $inject = ["$scope", "OmniaShell"]

    constructor(
        private $scope: ng.IScope,
        private readonly shell: IOmniaShell,
        public readonly readOnly = shell.isReadOnly(p => p.mapLayers)
    ) {
    }

    $onInit() {
        this.setup()
    }

    private setup() {

        const layer = this.layer

        this.canReset = canReset(layer)
        this.totalYield = layer.datalayer.Value
            ? Number(layer.datalayer.Value)
            : calculateTotal(layer, l => Number(l.value ?? 0))
        this.originalTotalYield = calculateTotal(layer, l => Number(l.zone.InitValue ?? l.value ?? 0))

    }

    get layer() {
        return this.editor ? this.editor.layer : undefined
    }

    get harvestDate() {
        const layer = this.layer
        return layer?.datalayer?.Date
    }

    set harvestDate(value: Date) {
        this.layer.datalayer.Date = value
    }


    reset() {

        const msg = "You are about to reset the zones to their initial values. Are you sure ?"
        const title = "Zone values reset"

        shell.showYesNo(this.shell, msg, title).then(r => {
            if (r) {

                const { layer } = this

                layer.datalayer.Value = null
                resetOriginalYields(layer)
                this.setup()
                this.refresh()

            }
        })
    }

    recalibrate() {

        const { layer, originalTotalYield, weightedYield } = this

        if (!weightedYield) {
            return
        }

        layer.datalayer.Value = this.weightedYield.toString()

        const ratio = originalTotalYield / weightedYield

        for (const z of layer.zones) {

            const init = z.zone.InitValue

            if (init === undefined) {
                z.zone.InitValue = z.value
            }

            const initRate = Number(init ?? z.value ?? 0)

            z.setValue(Math.round((initRate / ratio) * 10) / 10, false)

        }

        this.totalYield = weightedYield
        this.canReset = true

        this.refresh()

    }

    private refresh() {

        this.editor.updateZoneValues()
        this.$scope.$broadcast("distribution.refresh")

    }

}


function calculateTotal(layer: Datalayer, rateSelector: (zone: DatalayerZone) => number) {
    const total = sum(layer.zones, z => calcYield(rateSelector(z), z.area))
    return total
}

function canReset(layer: Datalayer) {
    return layer && Boolean(layer.datalayer.Value) && layer.zones.some(z => z.zone.InitValue)
}

function calcYield(rate: number, aream2: number) {
    return rate !== undefined
        ? Math.round(rate * aream2 / 1000) / 10
        : undefined
}

function resetOriginalYields(layer: Datalayer) {

    for (const z of layer.zones) {

        const init = z.zone.InitValue

        if (init !== undefined) {
            z.setValue(Number(init), false)
            z.zone.InitValue = undefined
        }

    }

}
